import { dataQrcode } from 'dls-icons-data'
import { createIcon } from '../common'

const IconQrcode = /*#__PURE__*/createIcon(dataQrcode)
export default IconQrcode
